export default {
  users: 'Users',
  members: 'Members',
  currentUserSuffix: '(you)',
  invitePending: 'Invite pending',
  permission: 'Permission',
  inviteRole: {
    label: 'Role',
    placeholder: 'Role Type',
  },
  table: {
    nameHeader: 'Name',
    emailHeader: 'Email',
    roleHeader: 'Roles',
  },
  roleSelect: {
    manage: 'Manage',
    add: 'Add',
    hint: 'Select one or more roles',
    required: 'Required',
    minOneRole: 'At least one role required',
    lastAdminTooltip: 'At least one organisation admin is required',
  },
  organisation: 'organisation',
  project: 'project',
  site: 'site',
  filters: {
    searchPlaceholder: 'Search by name or email',
    roleFilter: 'Role',
    roleFilterCount: 'Role ({count})',
    roleFilterHint: 'Select one or more roles',
    toggleAriaLabel: 'Filter by user status',
    current: 'Current users',
    pending: 'Pending users',
  },
  confirm: {
    no: 'No, cancel',
    remove: {
      title: 'Remove user',
      p1: 'Are you sure you want to remove {email} from this {type}?',
      p2: 'This action will remove this user from any assigned projects or sites.',
      yes: 'Yes, remove user',
    },
    removeMulti: {
      title: 'Remove this user?',
      body: "This will revoke the following roles for {email}. This can't be undone.",
      yes: 'Remove user',
    },
    owner: {
      title: 'Change to Organisation Owner',
      body: 'Are you sure you want to change {email} to organisation owner?',
      yes: 'Yes, confirm',
    },
    roleChange: {
      title: 'Change to {role}',
      body: 'Are you sure you want to change {email} to {role}?',
      yes: 'Yes, confirm',
    },
    changeClientRole: {
      toApproval: {
        title: 'Change Client Role',
        body: 'Are you sure you want give {email} permission to approve client variations?',
        yes: 'Yes, confirm',
      },
      toBase: {
        title: 'Change Client Role',
        body: 'Are you sure you want remove permission to approve client variations for {email}?',
        yes: 'Yes, confirm',
      },
      default: {
        title: 'Change Role',
        body: 'Are you sure you want to change this role?',
        yes: 'Yes, confirm',
      },
    },
  },
  changeRole: {
    member: 'Change to Member',
    admin: 'Change to Admin',
    owner: 'Change to Org Owner',
  },
  userInvite: {
    placeholder: 'Invite by email',
    invalidEmail: 'Please ensure email address is valid',
    invite: 'Invite',
    exists: 'Invited',
  },
  toasts: {
    roleUpdate: {
      title: 'Permission updated',
      content: 'User permission access has been updated successfully',
    },
    invite: {
      title: 'User Invited',
      content: '{email} has been invited to the {scope} as {role}.',
    },
    roleAdded: {
      title: 'Role added',
      content: 'The {role} role has been added for {email}.',
    },
    roleRemoved: {
      title: 'Role removed',
      content: 'The {role} role has been removed for {email}.',
    },
    userRemoved: {
      title: 'User Removed',
      content: '{email} has been removed from the {scope}.',
    },
    userRemovedMultiRole: {
      title: 'User with multiple roles removed',
      content: '{email} has been removed from the {scope}.',
    },
    resendInvite: {
      title: 'Invite resent',
      content: 'Invite resent to {email}.',
    },
    alreadyAdded: {
      title: 'User exists',
      content:
        'This user is already a member of the organisation or has already received an invitation.',
    },
    alreadyAddedOrg: {
      title: 'Multiple roles not allowed',
      content: 'A user can have only one role in an organisation',
    },
    alreadyAddedRoleEmailCombo: {
      title: 'User exists with this role',
      content: 'A user with this email has already been added to this role',
    },
    changeClientRole: {
      title: 'Client role updated',
      content: 'Client role successfully updated',
    },
    clientRoleSwitch: {
      toApproval: {
        title: 'Approvals granted',
        content: '{email} can now approve client variations.',
      },
      toBase: {
        title: 'Approvals removed',
        content: '{email} can no longer approve client variations.',
      },
    },
  },
  roles: {
    org: {
      owner: 'Org owner',
      admin: 'Org admin',
      member: 'Org member',
    },
    boq: {
      owner: 'BOQ owner',
      admin: 'Org admin',
    },
    project: {
      manager: 'Project manager',
      member: 'Project member',
      owner: 'Project Owner',
      professional: 'Project professional',
      client: 'Project client',
    },
    site: {
      admin: 'Site Administrator',
      member: 'Site Member',
      procOff: 'Site Procurement Officer',
      finOff: 'Site Finance Officer',
      paymentOff: 'Site Payment Officer',
      fieldUser: 'Site Field User',
      professional: 'Site Professional',
      client: 'Site Client',
    },
  },
  changeOrgDialog: {
    title: 'Change Active Organisation',
    subtitle: 'Available organisations:',
  },
  orgSettingsUsers: {
    showProjectList: {
      title: 'User Projects',
      searchPlaceholder: 'Search by project or site name',
      accordion: {
        projectsLabel: 'Project',
        sitesLabel: 'Site',
        emptyStateMessage: 'This user does not have roles associated with any project or site',
        noSearchResultMessage: 'No project or site matches the name searched',
      },
      noSitesPlaceholder: 'This user has no site roles in this project',
    },
    resendInvite: 'Resend invite',
  },
  roleEvents: {
    remove: {
      title: 'Access removed from {entityType}',
      description:
        'Your access to this resource has been removed by an administrator. You will be redirected to a page you have permission to view.',
    },
    orgRemoved: {
      title: 'Access removed',
      heading: 'Your access to {organisation} was removed',
      description: 'An administrator removed your access. Choose another organisation to continue.',
      noOtherOrgsDescription:
        'An administrator removed your access, and you have no other organisations to switch to.',
      continueIn: 'Continue in',
    },
    roleRemoved: {
      title: 'A role has been removed',
      description:
        'The role above has been removed from your access by an administrator. You still have access to this organisation.',
    },
    add: {
      title: 'Access added to {entityType}',
      description: 'You have been added as another role on this resource',
    },
    update: {
      title: 'Access updated for {entityType}',
      description: 'Your access to this resource has been updated by an administrator.',
    },
    additionalMessage: 'Think this is a mistake? Contact your system administrator.',
  },
};
